
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'StatSection',
  props: {
    title: {
      type: String,
      default: undefined
    },
    helpText: {
      type: String,
      default: undefined
    },
    bodySpacing: {
      type: Number,
      default: 2
    },
    gridSpacing: {
      type: Number,
      default: 2
    },
    bodyIsGrid: {
      type: Boolean,
      default: true
    },
    customGridClass: {
      type: String,
      default: null
    },
    spacingClass: {
      type: String,
      default: null
    },
    headerSpacingClass: {
      type: String,
      default: null
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    fullWidth: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    gridGap(): number | null {
      // If body is grid, return grid spacing or body spacing whichever is available
      return this.bodyIsGrid ? (this.gridSpacing ?? this.bodySpacing) : null
    }
  }
})
